import React, { useEffect, useRef } from 'react';

import classes from './MediaPreviewModal.module.css';

const IframeComponent = ({ url }) => {
  const iframeRef = useRef(null);
  const timerIdRef = useRef(null);

  // Function to reload the iframe
  const reloadIFrame = () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
  };

  useEffect(() => {
    // Set up the interval to reload the iframe every 2 seconds
    timerIdRef.current = setInterval(reloadIFrame, 2000);

    // Clean up the interval when the component unmounts
    return () => {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
      }
    };
  }, []);

  // Handle iframe load event
  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const handleLoad = () => {
        clearInterval(timerIdRef.current); // Stop the interval
        console.log('Finally Loaded');
      };

      iframe.addEventListener('load', handleLoad);

      // Clean up the event listener
      return () => {
        iframe.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return (
    <iframe
      className={classes.frameContainer}
      id="iframeID"
      ref={iframeRef}
      src={`https://docs.google.com/viewerng/viewer?url=${url}&embedded=true`}
      title="Embedded Document"
    ></iframe>
  );
};

export default IframeComponent;
